import { useRef, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CollectionList from "../../widgets/CollectionList";
import TagInputBar from "./TagInputBar";
import { getAllTagsAction, storeAllTagsAction } from "../../api/actions/actions";
import TagsListItem from "./TagsListItem";
import { ReloadSvg, NewListSvg } from "../../icons/Icon";
import { useEventContext } from "../../contexts/EventContextProvider";
import { createTagCrudFromEvent } from "../../events/TagEvents";

const CustomActions = (p) => {

    const { state, eventDispatch } = useEventContext();
    const dispatch = useDispatch();

    const onReload = () => {
        dispatch(getAllTagsAction()).unwrap()
            .then((result) => {
                dispatch(storeAllTagsAction(result.content));
            })
            .catch((error) => {
                console.log("Custom Error:", error, error.error);
            });
    };
    const onNew = () => {
        eventDispatch(createTagCrudFromEvent());
    };

    return (
        <div className="CollectionList_actions">
            <button className="CollectionList_reload" onClick={onReload}><ReloadSvg /></button>
            <button className="CollectionList_new" onClick={onNew}><NewListSvg /></button>
        </div >
    );
}
const Tags = (p) => {

    const list = useRef(null);
    const inputBar = useRef(null);
    const dispatch = useDispatch();
    const allTags = useSelector((state) => state.base.tags);

    useEffect(() => {
        if (!(Array.isArray(allTags) && allTags.length > 0)) {
            dispatch(getAllTagsAction()).unwrap()
                .then((result) => {
                    //console.log('storeAllTagsAction', result.content);
                    dispatch(storeAllTagsAction(result.content));
                })
                .catch((error) => {
                    console.log("Custom Error:", error, error.error);
                });
        }
    }, []);
    const onSelect = () => {

    };
    return (
        <div className="page">
            <div className="flex-24">
                <div className="col-24 flex-column">
                    <div className="page-box">
                        <div className='page-box-header'>
                            <h4><span>Tags Management</span></h4>
                        </div>
                        <div className='page-box-body'>
                            <TagInputBar ref={inputBar} />
                            <CollectionList
                                ref={list}

                                selectable={true}
                                onSelect={onSelect}
                                itemsPerPage={10}
                                items={allTags}

                                ItemsComponent={TagsListItem}
                                CustomActionsComponent={(p) => <CustomActions listRef={list.current} />}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Tags;